/* eslint-disable showpass-custom/no-hardcoded-colors */
/* eslint-disable showpass-custom/no-hardcoded-style-values */
import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function DiscoverLogo({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <DiscoverLogo.Outline {...props} />
  ) : (
    <DiscoverLogo.Solid {...props} />
  );
}

DiscoverLogo.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For outlined icons, be sure to add `className="icon-outline"`
         * to each path that needs to be outlined.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

DiscoverLogo.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <rect width="70" height="48" rx="4" fill="#232342" />
        <path
          d="M30.5 48L70 36.5V44C70 46.2091 68.2092 48 66 48H30.5Z"
          fill="#FD6020"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M60.3711 19.2217C62.5442 19.2217 63.7394 20.1888 63.7394 22.0155C63.8481 23.4124 62.8702 24.5944 61.5663 24.8093L64.5 28.7851H62.2182L59.7192 24.9168H59.5018V28.7851H57.6547V19.2217H60.3711ZM59.5018 23.6273H60.0451C61.2403 23.6273 61.7836 23.09 61.7836 22.1229C61.7836 21.2633 61.2403 20.726 60.0451 20.726H59.5018V23.6273ZM51.244 28.7851H56.4595V27.1733H53.0912V24.5944H56.3508V22.9826H53.0912V20.8335H56.4595V19.2217H51.244V28.7851ZM45.8112 25.6689L43.3122 19.2217H41.3564L45.3766 29H46.3545L50.3748 19.2217H48.419L45.8112 25.6689ZM23.7541 24.0571C23.7541 26.7435 25.9273 29 28.6436 29C29.5129 29 30.2735 28.7851 31.0341 28.4627V26.3137C30.4908 26.9584 29.7302 27.3882 28.861 27.3882C27.1225 27.3882 25.7099 26.0987 25.7099 24.3795V24.1646C25.6013 22.4453 27.0138 20.941 28.7523 20.8335C29.6215 20.8335 30.4908 21.2633 31.0341 21.908V19.759C30.3821 19.3291 29.5129 19.2217 28.7523 19.2217C25.9273 19.0068 23.7541 21.2633 23.7541 24.0571ZM20.3858 22.8751C19.2993 22.4453 18.9733 22.2304 18.9733 21.6931C19.082 21.0484 19.6252 20.5111 20.2772 20.6186C20.8204 20.6186 21.3637 20.941 21.7983 21.3708L22.7762 20.0813C22.0157 19.4366 21.0378 19.0068 20.0599 19.0068C18.5387 18.8993 17.2348 20.0813 17.1262 21.5857V21.6931C17.1262 22.9826 17.6694 23.7348 19.4079 24.272C19.8425 24.3795 20.2772 24.5944 20.7118 24.8093C21.0378 25.0242 21.2551 25.3466 21.2551 25.7764C21.2551 26.5286 20.6031 27.1733 19.9512 27.1733H19.8425C18.9733 27.1733 18.2127 26.636 17.8867 25.8838L16.6915 27.0658C17.3435 28.2478 18.6473 28.8925 19.9512 28.8925C21.6897 29 23.1022 27.7106 23.2109 25.9913V25.6689C23.1022 24.3795 22.5589 23.7348 20.3858 22.8751ZM14.0838 28.7851H15.9309V19.2217H14.0838V28.7851ZM5.5 19.2217H8.21639H8.75967C11.3674 19.3292 13.4319 21.4782 13.3232 24.0571C13.3232 25.454 12.6713 26.7435 11.5847 27.7106C10.6068 28.4627 9.4116 28.8926 8.21639 28.7851H5.5V19.2217ZM7.89042 27.1733C8.75966 27.2807 9.73756 26.9584 10.3895 26.4211C11.0414 25.7764 11.3674 24.9168 11.3674 23.9497C11.3674 23.09 11.0414 22.2304 10.3895 21.5857C9.73756 21.0484 8.75966 20.7261 7.89042 20.8335H7.34714V27.1733H7.89042Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M36.5763 19C33.8599 19 31.5781 21.1491 31.5781 23.9429C31.5781 26.6292 33.7512 28.8858 36.5763 28.9932C39.4013 29.1007 41.5744 26.8441 41.6831 24.0503C41.5744 21.2565 39.4013 19 36.5763 19V19Z"
          fill="#FD6020"
        />
      </>
    ),
  });

  return <Icon viewBox="0 0 70 48" {...validateKeys(props)} />;
};
